
import { Button, Col, Form, message, Modal, Row, Space, Table, Tabs } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import servicePath from '../config/apiUrl';
import '../static/css/CameraList.css';
const { confirm } = Modal;
const tabList = [
  {
    name: '全部',
    id: 'all'
  },
  {
    name: '浪报',
    id: '1'
  },
  {
    name: '攻略',
    id: '2'
  },
  {
    name: '活动',
    id: '3'
  },
  {
    name: '准备周边',
    id: '4'
  },
  {
    name: '其他',
    id: '5'
  }
];
function NewslList(props) {
  const [keyword, setKeyword] = useState('')
  const [type, setType] = useState('all')
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 20,
    },
  });
  const [list, setList] = useState([])
  //得到文章列表
  const getList = (currentPage) => {
    const key = 'getList';

    message.loading({ content: '加载数据...', key });
    axios({
      method: 'post',
      url: servicePath.getNewsList,
      withCredentials: true,
      data: {
        keyword: keyword,
        type: type,
        page: currentPage ? currentPage : (tableParams.pagination?.current || 1)
      },
      header: { 'Access-Control-Allow-Origin': '*' }
    }).then(
      res => {
        if (res.data.code == 1) {
          let respData = res.data?.data || {}
          setList(respData?.list || [])
          setTableParams({
            ...tableParams,
            pagination: {
              current: respData?.currentPage || 1,
              pageSize: 20,
              total: respData?.totalCount || 0,
            },
          });
          message.success({ content: '加载数据成功！', key, duration: 2 });
        } else {
          setList([])
          message.error({ content: '加载数据失败！', key, duration: 2 });
        }
      }
    ).catch((res) => {
      setList([])
      message.error({ content: '加载数据失败！', key, duration: 2 });
    })
  }
  useEffect(() => {
    getList(1)
  }, [type, keyword])

  //删除文章
  const deleteNewsInfo = (id) => {
    confirm({
      title: '确定要删除该文章信息吗?',
      content: '如果你点击OK按钮，将会永远被删除，无法恢复。',
      onOk() {
        axios(servicePath.deleteNewsInfo + '/' + id, { withCredentials: true }).then(
          res => {
            message.success('文章删除成功')
            getList()
          }
        )
      },
      onCancel() {
        message.info('取消删除')
      },
    });

  }
  //修改文章
  const editNewsInfo = (id, checked) => {
    props.history.push('/news/editNews/' + id)
  }

  const onChangeTabs = (key) => {
    setType(key)
  };
  // 定义列配置
  const columns = [
    { title: '文章ID', dataIndex: 'newsId', key: 'newsId' },
    { title: '标题', dataIndex: 'title', key: 'title' },
    { title: '描述', dataIndex: 'description', key: 'description' },
    {
      title: 'banner图片',
      dataIndex: 'post_url',
      key: 'post_url',
      render: post_url => <img style={{ width: '60px', height: 'auto' }} src={servicePath.serverUrl + post_url} alt='banner图' />
    },
    {
      title: '文章类型',
      dataIndex: 'type',
      key: 'type',
      render: (value) => {
        // 根据 tabList 的数组来匹配返回的type id 渲染name 字段
        let type = tabList.find(item => item.id == value)
        return type?.name || '-'
      }
    },
    {
      title: '是否展示',
      dataIndex: 'hide',
      key: 'hide',
      render: hide => (hide === 1 ? '不展示' : '展示')
    },
    {
      title: '操作',
      key: 'action',
      render: (text, record) => (
        <Space size="middle">
          <Button type="primary" onClick={() => { editNewsInfo(record.newsId) }}>修改</Button>
          <Button onClick={() => { deleteNewsInfo(record.newsId) }}>删除</Button>
        </Space>
      )
    }
  ];


  const handleTableChange = (
    pagination
  ) => {
    setTableParams({
      pagination
    });
    getList(pagination.current)
  };
  const [form] = Form.useForm();

  const onFinish = (values) => {
    setKeyword(values?.keyword || '')
  };
  return (

    <div>

      <Form
        form={form}
        name="control-hooks"
        onFinish={onFinish}
        style={{
          maxWidth: '100%',
        }}
      >
        <Row gutter={16}>
          {/* <Col className="gutter-row" span={16}>
            <Form.Item
              name="keyword"
              label="搜索关键词"
            >
              <Input />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={6}>
            <Form.Item >
              <Space>
                <Button type="primary" htmlType="submit">
                  搜索
                </Button>

              </Space>
            </Form.Item>
          </Col> */}
          <Col className="gutter-row" span={24}>
            <Tabs defaultActiveKey="all" onChange={onChangeTabs}>
              {tabList.map(tab => (
                <Tabs.TabPane tab={tab.name} key={tab.id}>
                  {tab.content}
                </Tabs.TabPane>
              ))}
            </Tabs>
          </Col>
        </Row>
      </Form>


      <Table dataSource={list} bordered columns={columns} onChange={handleTableChange} pagination={tableParams.pagination} />
    </div>
  )

}

export default NewslList